import React, { useRef } from "react";
import { Form, Select, Label } from "semantic-ui-react";

export const TextInput = ({
  children,
  input,
  width,
  type,
  placeholder,
  label,
  disabled,
  isRequired,
  meta: { touched, error, warning },
}) => {
  const errorClass = error ? "error" : "";
  const warningClass = warning ? "warning" : "";
  return (
    <Form.Field error={touched && !!error} width={width}>
      <div
        className={touched ? ` field ${errorClass}${warningClass}` : "field"}
      >
        {label && (
          <label htmlFor={input.name}>
            {label} {isRequired && <span>*</span>}
          </label>
        )}
        {children}
        <input
          {...input}
          placeholder={placeholder}
          type={type}
          id={input.name}
          disabled={disabled}
        />
        {touched && (error || warning) && (
          <Label basic color={error ? "red" : "orange"} pointing>
            {error || warning}
          </Label>
        )}
      </div>
    </Form.Field>
  );
};

export const SelectInput = ({
  input,
  width,
  label,
  placeholder,
  multiple,
  options,
  disabled,
  isRequired,
  meta: { touched, error },
}) => {
  const list = options.sort((a, b) => {
    let x = a.text.toLowerCase(),
      y = b.text.toLowerCase();
    if (x < y) return -1;
    if (x > y) return 1;
    return 0;
  });
  return (
    <Form.Field width={width}>
      {label && (
        <label htmlFor={input.name}>
          {label} {isRequired && <span>*</span>}
        </label>
      )}
      <Select
        value={input.value || null}
        onChange={(e, data) => {
          input.onChange(data.value);
        }}
        placeholder={placeholder}
        options={list}
        multiple={multiple}
        id={input.name}
        className="fluid"
        disabled={disabled}
      />
      {touched && error && (
        <Label basic color="red">
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export const CheckboxInput = ({
  input,
  disable,
  width,
  type,
  label,
  meta: { touched, error },
}) => {
  return (
    <Form.Field error={touched && !!error} className="checkbox">
      <div className="ui checkbox">
        {disable ? (
          <input {...input} type={type} id={input.name} disabled />
        ) : (
          <input {...input} type={type} id={input.name} />
        )}
        {label && <label htmlFor={input.name}>{label}</label>}
        {touched && error && (
          <Label basic color="red">
            {error}
          </Label>
        )}
      </div>
    </Form.Field>
  );
};

export const RadioInput = ({
  input,
  radioValue,
  label,
  meta: { touched, error },
}) => {
  return (
    <Form.Field error={touched && !!error}>
      <div class="ui radio checkbox">
        <input
          {...input}
          type="radio"
          name={input.name}
          value={radioValue}
          checked={input.value === radioValue}
        />
        {label && <label htmlFor={input.name}>{label}</label>}
      </div>
    </Form.Field>
  );
};

export const FileInput = ({
  input,
  width,
  fileName,
  callback,
  handleFileRemove,
  meta: { touched, error },
}) => {
  const fileRef = useRef(null);

  const handleFileChange = (event) => {
    callback(event.target.files[0]);
  };

  return (
    <Form.Field error={touched && !!error}>
      <div className="ui action input">
        <input
          type="file"
          hidden
          {...input}
          value=""
          ref={fileRef}
          onChange={handleFileChange}
        />
        <input type="text" disabled value={fileName} />
        <button
          className="ui button positive"
          onClick={(e) => {
            fileRef.current.click();
          }}
          type="button"
        >
          Add
        </button>
        <button
          className="ui button"
          type="button"
          onClick={handleFileRemove}
          disabled={!fileName}
        >
          Clear
        </button>
      </div>
    </Form.Field>
  );
};

export const AdvertiserOptions = ({ advertisers }) => {
  return advertisers.map((advertiser) => {
    return (
      <option value={advertiser.displayName} key={advertiser.advertiserId}>
        {advertiser.displayName}
      </option>
    );
  });
};
